import pako from 'pako';
import { Base64 } from 'js-base64';
import axios from 'axios';

export const deflateFromFile = async (originalObject) => {
    if (!(originalObject instanceof File)) {
        throw Error("Not File type")
    }
    const buffer = await originalObject.arrayBuffer();
    const rawUint8 = new Uint8Array(buffer);
    const gzipedUint8 = pako.deflate(rawUint8);
    const gzipedBase64 = Base64.fromUint8Array(gzipedUint8);
    return gzipedBase64;
}

export const deflateFromGzipUrl = async (url) => {
    const buffer = await axios.get(url, {
        responseType: 'arraybuffer',
        timeout: 60000
    }).then(response => response.data);
    const gzipedUint8 = new Uint8Array(buffer);
    const gzipedBase64 = Base64.fromUint8Array(gzipedUint8);
    return gzipedBase64;
}

export const inflateToFile = async (gzipedBase64, fn, type) => {
    const gzipedUint8 = Base64.toUint8Array(gzipedBase64);
    const rawUint8 = pako.inflate(gzipedUint8);
    const buffer = rawUint8.buffer
    const rawFile = new File([buffer], fn, { type });
    rawFile.filestring = await rawFile.text()
    return rawFile;
}
